import { o_util } from "@gr-common/async/namespaces";
import { otto } from "@gr-exports/async/nexus";
const apm = otto.apm ?? {};
const agent = apm.agent;
const isActive = apm.isActive;
const getCurrentTransaction = apm.getCurrentTransaction;
const startSpan = apm.startSpan;
const captureError = apm.captureError;
const mark = apm.mark;
const addLabels = apm.addLabels;
const sendCustomError = apm.sendCustomError;
const apmSync = o_util.apm ?? {};
const runWithSpan = apmSync.runWithSpan;
const withSpan = apmSync.withSpan;
export {
  addLabels,
  agent,
  apm,
  apmSync,
  captureError,
  getCurrentTransaction,
  isActive,
  mark,
  runWithSpan,
  sendCustomError,
  startSpan,
  withSpan
};
